import { Swiper, SwiperSlide } from "swiper/react";
import PropTypes from "prop-types";

import { Navigation } from "swiper";

import { highlighterQuickInfoLine } from "helpers/listing-card/quick-info-line";
import { calculatePercentage } from "helpers/calculate-percentage";
import { createHighlighterBadge } from "helpers/create-highlighter-badge";

import HighlighterListingCard from "src/components/homepage/highlighter-card/listing-card";
import SwiperWrapper from "src/components/swiper-wrapper";
import Container from "components/grid/container";

import styles from "./styles.module.css";

export const PlatinumListing = ({ platinumListings }) => {
  const {
    listingCard: { records: listings },
  } = platinumListings || {};

  return (
    <div className={styles.wrapper}>
      <Container>
        <p className={styles.title}>Platin İlanlar</p>
        <SwiperWrapper>
          <Swiper navigation={true} loop={listings.length > 4} modules={[Navigation]} slidesPerView={4}>
            {listings.map((listingItem) => {
              const quickInfoList = highlighterQuickInfoLine(
                listingItem?.squareMeter,
                listingItem?.estateTypeName,
                listingItem?.quickInfos
              );

              const percentageBadge = calculatePercentage(
                listingItem?.priceDetail?.previousPrice,
                listingItem?.priceDetail?.price
              );

              const category = listingItem?.categoryTypeName;
              const meterArea = listingItem?.quickInfos?.find((i) => i?.key === "square");
              const meterPrice = listingItem?.quickInfos?.find((i) => i?.key === "square_meter_price");

              const badge = createHighlighterBadge("platinum", listingItem?.badges, percentageBadge);

              return (
                <SwiperSlide key={listingItem?.id}>
                  <div>
                    <HighlighterListingCard
                      quickInfo={quickInfoList}
                      listItemInfo={listingItem}
                      badges={badge}
                      // gtmEventLabel={eventLabel}
                      meterArea={category === "Arsa" && meterArea?.value}
                      meterPrice={category === "Arsa" && meterPrice?.value}
                    />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </SwiperWrapper>
      </Container>
    </div>
  );
};

PlatinumListing.propTypes = {
  platinumListings: PropTypes.object,
};
